// Development stages data for the Indie Dev Toolkit
import type { DevStage } from '../types/index.js';

export const devStagesData: DevStage[] = [
  {
    stage: 'Ideation & Research',
    description: 'Validate your app idea and understand the market',
    tools: [
      { name: 'Sensor Tower', url: 'https://sensortower.com', description: 'Mobile app store optimization & intelligence', cost: 'Free/Paid', tier: 'freemium' },
      { name: 'SimilarWeb', url: 'https://www.similarweb.com', description: 'Website & app traffic analytics', cost: 'Free/Paid', tier: 'freemium' }
    ]
  },
  {
    stage: 'Market Validation',
    description: 'Test your concept with potential users',
    tools: [
      { name: 'TypeForm', url: 'https://www.typeform.com', description: 'Beautiful surveys and forms', cost: 'Free/Paid', tier: 'freemium' },
      { name: 'Maze', url: 'https://maze.co', description: 'User testing platform', cost: 'Free/Paid', tier: 'freemium' }
    ]
  },
  {
    stage: 'Design & Prototyping',
    description: 'Create wireframes, designs, and interactive prototypes',
    tools: [
      { name: 'Figma', url: 'https://www.figma.com', description: 'Collaborative design platform', cost: 'Free/Paid', tier: 'freemium' },
      { name: 'Sketch', url: 'https://www.sketch.com', description: 'Digital design toolkit', cost: 'Paid', tier: 'paid' }
    ]
  },
  {
    stage: 'Development',
    description: 'Build your iOS application',
    tools: [
      { name: 'Xcode', url: 'https://developer.apple.com/xcode/', description: 'Official iOS development IDE', cost: 'Free', tier: 'free' },
      { name: 'GitHub', url: 'https://github.com', description: 'Code hosting and version control', cost: 'Free/Paid', tier: 'freemium' },
      { name: 'Cursor', url: 'https://cursor.sh', description: 'AI-powered code editor', cost: 'Free/Paid', tier: 'freemium' }
    ]
  },
  {
    stage: 'Backend & APIs',
    description: 'Set up server infrastructure and data management',
    tools: [
      { name: 'Firebase', url: 'https://firebase.google.com', description: 'Backend-as-a-Service platform', cost: 'Free/Paid', tier: 'freemium' },
      { name: 'Supabase', url: 'https://supabase.com', description: 'Open source Firebase alternative', cost: 'Free/Paid', tier: 'freemium' },
      { name: 'RevenueCat', url: 'https://www.revenuecat.com', description: 'In-app purchase management', cost: 'Free/Paid', tier: 'freemium' }
    ]
  },
  {
    stage: 'Testing & QA',
    description: 'Ensure quality and performance',
    tools: [
      { name: 'TestFlight', url: 'https://developer.apple.com/testflight/', description: 'Beta testing for iOS apps', cost: 'Free', tier: 'free' },
      { name: 'Crashlytics', url: 'https://firebase.google.com/products/crashlytics', description: 'Crash reporting and analytics', cost: 'Free', tier: 'free' },
      { name: 'Flipper', url: 'https://fbflipper.com', description: 'Debugging platform for mobile apps', cost: 'Free', tier: 'free' }
    ]
  },
  {
    stage: 'App Store Prep',
    description: 'Prepare for App Store submission',
    tools: [
      { name: 'App Store Connect', url: 'https://appstoreconnect.apple.com', description: 'Official app submission platform', cost: 'Free', tier: 'free' },
      { name: 'Astro', url: 'https://tryastro.app', description: 'App Store Optimization platform', cost: 'Free/Paid', tier: 'freemium' },
      { name: 'The App Store Review Guidelines', url: 'https://developer.apple.com/app-store/review/guidelines/', description: 'Official submission guidelines', cost: 'Free', tier: 'free' }
    ]
  },
  {
    stage: 'Launch & Marketing',
    description: 'Launch your app and drive initial downloads',
    tools: [
      { name: 'Product Hunt', url: 'https://www.producthunt.com', description: 'Launch platform for new products', cost: 'Free', tier: 'free' },
      { name: 'Buffer', url: 'https://buffer.com', description: 'Social media management', cost: 'Free/Paid', tier: 'freemium' }
    ]
  },
  {
    stage: 'Analytics & Growth',
    description: 'Track performance and optimize for growth',
    tools: [
      { name: 'App Store Connect Analytics', url: 'https://appstoreconnect.apple.com', description: 'Official App Store analytics', cost: 'Free', tier: 'free' },
      { name: 'Mixpanel', url: 'https://mixpanel.com', description: 'Advanced product analytics', cost: 'Free/Paid', tier: 'freemium' },
      { name: 'Amplitude', url: 'https://amplitude.com', description: 'Digital optimization platform', cost: 'Free/Paid', tier: 'freemium' }
    ]
  },
  {
    stage: 'User Feedback',
    description: 'Collect and manage user feedback',
    tools: [
      { name: 'App Store Reviews', url: 'https://developer.apple.com/app-store/ratings-and-reviews/', description: 'Official review management', cost: 'Free', tier: 'free' },
      { name: 'UserVoice', url: 'https://www.uservoice.com', description: 'Customer feedback management', cost: 'Paid', tier: 'paid' },
      { name: 'Instabug', url: 'https://instabug.com', description: 'In-app feedback and bug reporting', cost: 'Free/Paid', tier: 'freemium' }
    ]
  }
];